export class CreatePageDTO {
  constructor(page) {
    this.title = page.title;
    this.description = page.description;
    this.email = page.email;
    this.phone = page.phone;
    this.level = page.level;
    this.dcc = page.dcc;
    this.lcc = page.lcc;
    this.nameOfLc = page.nameOfLc;
  }

  createEmpty() {
    return new CreatePageDTO({
      title: "",
      description: "",
      email: "",
      level: "hq",
      dcc: "",
      lcc: "",
      nameOfLc: "",
      phone: { number: "" },
    });
  }
}

export class UpdatePageDTO extends CreatePageDTO {
  constructor(page) {
    super(page);
    this.id = page.id;
    this.isActive = page.isActive;
    this.dcc = page.dcc ? page.dcc.id : null;
    this.lcc = page.lcc ? page.lcc.id : null;
    this.nameOfDcc = page.dcc?.name;
    this.nameOfLcc = page.lcc?.name;
    this.nameOfLc = page.nameOfLc;
    this.coverPicture = page.coverPicture;
    this.profilePicture = page.profilePicture;
  }
}
